/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './DividendsOption.scss';

import classnames from 'classnames';
import { bool, func, node, number, string } from 'prop-types';
import React from 'react';

import {AAMBeaconControl, AAMBeaconControlGroup} from "components/shared/Beacon";
import {REINVEST_ID} from "../../../../services/Preferences";

const DividendsOption = ({
                             children,
                             label,
                             onChange,
                             selected,
                             value,
                             title = 'Dividend Distributions',
                             isBrokerage = false
}) => {
    const inputName = label.split(' ').join('-');
    const wrapperClassname = classnames('dividends-option-wrapper-v2', { selected });

    return (
        <div className={wrapperClassname}>
            <div className="dividends-option-v2">
                {selected && (
                    <div className="dividends-label-v2">{title}</div>
                )}
              <div className="beacon-on-light">
                <AAMBeaconControlGroup>
                    <AAMBeaconControl inline>
                        <label htmlFor={`div-cap-gains-radio-${label}`}
                            slot="label">
                            {label}
                        </label>
                        <input type="radio"
                            onChange={() => onChange(value)}
                            checked={selected}
                            value={inputName}
                            id={`div-cap-gains-radio-${label}`}
                            name={`div-cap-gains-radio-${label}`} />
                    </AAMBeaconControl>
                </AAMBeaconControlGroup>
            </div>
                {selected && children}
            </div>
            {(
              isBrokerage &&
              value === REINVEST_ID &&
              selected
              ) &&
                <div>
                Not all holdings in your brokerage account allow Reinvest Dividend
                Payments as an option. If the holding does not offer this option,
                the election will remain as Cash after being in a pending status
                for 5 calendar days.
                </div>
            }
        </div>
    );
};

DividendsOption.propTypes = {
    children: node,
    label: string.isRequired,
    onChange: func.isRequired,
    selected: bool.isRequired,
    value: number.isRequired
};

export default DividendsOption;
